import moment from "moment";

// กฎเวลาจองห้อง ใช้ตอนแอดมินสร้าง/แก้การจองใน portal
// ต้องตรงกับฝั่งลูกค้า (web-app) และ API (roomBookingService.draft):
// - web-app MusicHallRegisBookingForm (Music Hall)
// - web-app MusicPracticeRoomSelectDateForm (ห้องซ้อม)
// ค่าเวลาใน portal เป็น string "HH.MM" (Dropdown ส่ง e.value) ไม่ใช่ object แบบฝั่งลูกค้า

const BUILD_TIME_OPTIONS = (from, to) => {
  const options = [];
  for (let m = TO_MINUTES(from); m <= TO_MINUTES(to); m += 30) {
    const hh = String(Math.floor(m / 60)).padStart(2, "0");
    const mm = String(m % 60).padStart(2, "0");
    options.push({ value: `${hh}.${mm}`, label: `${hh}:${mm}` });
  }
  return options;
};

// "09.30" -> 570 (parseFloat ใช้คำนวณช่วงห่างไม่ได้ เพราะ 9.30 ไม่ใช่ 9.5)
export const TO_MINUTES = (time) => {
  const [hour, minute] = String(time).split(".").map(Number);
  return hour * 60 + (minute || 0);
};

const HAS = (time) => !!time;

// ==================== MUSIC HALL ====================
// ลำดับเวลา: เริ่มเตรียมงาน < เริ่มงาน < จบงาน <= จบเก็บงาน
export const MUSIC_HALL_TIME_OPTIONS = BUILD_TIME_OPTIONS("07.00", "22.00");

export const FILTER_SETUP_END_TIME = (setupStart) =>
  !HAS(setupStart)
    ? MUSIC_HALL_TIME_OPTIONS
    : MUSIC_HALL_TIME_OPTIONS.filter(
        (e) => TO_MINUTES(e.value) > TO_MINUTES(setupStart),
      );

// เวลาเริ่มงานต้องอยู่ในช่วงเตรียมงาน
export const FILTER_EVENT_START_TIME = (setupStart, setupEnd) =>
  MUSIC_HALL_TIME_OPTIONS.filter(
    (e) =>
      (!HAS(setupStart) || TO_MINUTES(e.value) >= TO_MINUTES(setupStart)) &&
      (!HAS(setupEnd) || TO_MINUTES(e.value) < TO_MINUTES(setupEnd)),
  );

// เวลาจบงานต้องหลังเวลาเริ่มงาน และไม่เกินเวลาเก็บงาน
export const FILTER_EVENT_END_TIME = (eventStart, setupEnd) =>
  MUSIC_HALL_TIME_OPTIONS.filter(
    (e) =>
      (!HAS(eventStart) || TO_MINUTES(e.value) > TO_MINUTES(eventStart)) &&
      (!HAS(setupEnd) || TO_MINUTES(e.value) <= TO_MINUTES(setupEnd)),
  );

// ค่าที่เลือกไว้ยังอยู่ในตัวเลือกหรือไม่ (เปลี่ยนเวลาอื่นแล้วค่าเดิมใช้ไม่ได้ ต้องล้าง)
export const IS_IN_OPTIONS = (time, options) =>
  !HAS(time) || options.some((e) => e.value === time);

// ==================== PRACTICE ROOM ====================
// จอง 09.00 - 17.30 ขั้นต่ำ 30 นาที (API draft: PRACTICE_ROOM_LAST_END_TIME / PRACTICE_ROOM_MIN_BOOKING_MINUTES)
export const PRACTICE_ROOM_MIN_BOOKING_MINUTES = 30;
const PRACTICE_ROOM_TIME_OPTIONS = BUILD_TIME_OPTIONS("09.00", "17.30");
const PRACTICE_ROOM_FIRST = PRACTICE_ROOM_TIME_OPTIONS[0].value;
const PRACTICE_ROOM_LAST =
  PRACTICE_ROOM_TIME_OPTIONS[PRACTICE_ROOM_TIME_OPTIONS.length - 1].value;

const IS_MIN_DURATION = (start, end) =>
  TO_MINUTES(end) - TO_MINUTES(start) >= PRACTICE_ROOM_MIN_BOOKING_MINUTES;

// เริ่มได้ถึง 17.00 (ต้องเหลือเวลาจบอย่างน้อย 30 นาที ก่อน 17.30)
export const PRACTICE_ROOM_START_TIME_OPTIONS =
  PRACTICE_ROOM_TIME_OPTIONS.filter((e) =>
    IS_MIN_DURATION(e.value, PRACTICE_ROOM_LAST),
  );

export const FILTER_PRACTICE_ROOM_END_TIME = (start) =>
  PRACTICE_ROOM_TIME_OPTIONS.filter((e) =>
    IS_MIN_DURATION(HAS(start) ? start : PRACTICE_ROOM_FIRST, e.value),
  );

// ห้องซ้อมปิดทุกวันจันทร์ (0=อาทิตย์ 1=จันทร์) ต้องตรงกับ API PRACTICE_ROOM_CLOSED_WEEKDAY
export const PRACTICE_ROOM_CLOSED_WEEKDAYS = [1];
export const IS_PRACTICE_ROOM_CLOSED_DAY = (date) =>
  !!date && PRACTICE_ROOM_CLOSED_WEEKDAYS.includes(moment(date).day());
